// src/lib/menuReviewConfig.js
// ⚠️ Fichier PARTAGÉ entre PageEditor.jsx, PublicPage.jsx et MenuPageEditor.jsx
// Config + helpers pour les blocs "menu" (carte NFC restaurant/café) et "google_review"

/* ============================================
   HELPERS — IDENTIFIANTS UNIQUES
   ============================================ */
let idCounter = 0

function uid(prefix = 'id') {
  const c = typeof crypto !== 'undefined' ? crypto : null

  if (c && typeof c.randomUUID === 'function') {
    return `${prefix}-${c.randomUUID()}`
  }

  idCounter += 1
  return `${prefix}-${Date.now()}-${idCounter}-${Math.random().toString(36).slice(2, 10)}`
}

/* ============================================
   DEFAULTS — BLOC MENU
   ============================================ */
export const DEFAULT_MENU_CONTENT = {
  title: 'Notre Menu',
  currency: 'DH',
  categories: [
    {
      id: 'cat-1',
      name: 'Entrées',
      items: [
        {
          id: 'item-1',
          name: 'Salade César',
          description: 'Poulet grillé, parmesan, croûtons',
          price: '45',
          image: '',
          tags: [],
          uncertain: false,
        },
      ],
    },
    {
      id: 'cat-2',
      name: 'Plats',
      items: [
        {
          id: 'item-2',
          name: 'Tajine Poulet',
          description: 'Olives, citron confit',
          price: '80',
          image: '',
          tags: [],
          uncertain: false,
        },
      ],
    },
  ],
}

/* ============================================
   DEFAULTS — BLOC AVIS GOOGLE
   ============================================ */
export const DEFAULT_GOOGLE_REVIEW_CONTENT = {
  businessName: 'Mon Établissement',
  googleUrl: '',
  rating: '4.8',
  reviewCount: '',
  ctaLabel: 'Laisser un avis Google',
}

/* ============================================
   HELPERS — MENU
   ============================================ */

// Nom vide volontairement : l'éditeur affiche un placeholder,
// et handleSave ignore les plats/catégories sans nom.
export function makeEmptyCategory() {
  return { id: uid('cat'), name: '', items: [] }
}

export function makeEmptyItem() {
  return {
    id: uid('item'),
    name: '',
    description: '',
    price: '',
    image: '',
    tags: [],
    uncertain: false,
  }
}

export function formatPrice(price, currency) {
  if (price === '' || price === null || price === undefined) return ''

  const p = String(price).trim()
  if (!p) return ''

  // Si le prix contient déjà une devise ou du texte (ex: "45 DH", "€12"),
  // on ne rajoute pas la devise une 2e fois.
  if (/[a-zA-Z€$£]/.test(p)) return p

  return `${p} ${currency || 'DH'}`
}

/* ============================================
   HELPERS — GOOGLE REVIEW
   ============================================ */
export function buildGoogleReviewUrl({ googleUrl, placeId }) {
  if (googleUrl && googleUrl.trim()) return googleUrl.trim()

  if (placeId && placeId.trim()) {
    return `https://search.google.com/local/writereview?placeid=${encodeURIComponent(placeId.trim())}`
  }

  return ''
}